<!-- ÜGYFELEK (foglalkoztatók) – a BÉR belépési pontja: a csempére kattintva az ügyfél megnyílik. -->
<div class="n-oldalfej">
  <div>
    <h2>Ügyfelek (foglalkoztatók)</h2>
    <span class="n-alcim">Válaszd ki, kinek a bérszámfejtésével dolgozol</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto">Hónap
    <select [ngModel]="aktiv.ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button (click)="importNyit()"><ion-icon slot="start" name="download-outline"></ion-icon>Import NAPLO-ból</ion-button>
  <ion-button (click)="uj()"><ion-icon slot="start" name="add"></ion-icon>Új ügyfél</ion-button>
</div>

<div *ngIf="ugyfelek.length" class="n-szuro-sor">
  <input type="search" [(ngModel)]="szuroNev" placeholder="Név / azonosító" class="ber-kereso">
  <input type="search" [(ngModel)]="szuroAdoszam" placeholder="Adószám" inputmode="numeric">
  <select [(ngModel)]="szuroForma">
    <option value="">Minden adózási forma</option>
    <option *ngFor="let f of ['TAO', 'KIVA', 'Átalányadó', 'KATA', 'Vállalkozói SZJA', 'Magánszemély']" [value]="f">{{ f }}</option>
  </select>
  <button type="button" class="ov-link" (click)="szuroTorol()" *ngIf="szuroNev || szuroAdoszam || szuroForma">Szűrő törlése</button>
  <span class="spacer"></span>
  <span class="halvany">{{ szurtUgyfelek.length }} / {{ ugyfelek.length }}</span>
</div>

<div *ngIf="!ugyfelek.length" class="ures"><ion-icon name="business-outline"></ion-icon>Még nincs ügyfél. Importálj a NAPLO-ból, vagy vegyél fel újat.</div>
<div *ngIf="ugyfelek.length && !szurtUgyfelek.length" class="ures"><ion-icon name="search-outline"></ion-icon>Nincs a szűrőnek megfelelő ügyfél.</div>

<div class="naplo-grid">
  <div class="ugyfel-tile ber-tile" *ngFor="let u of szurtUgyfelek" [class.aktiv]="u.id === aktiv.ugyfelId" [class.inaktiv]="u.inaktiv"
       (click)="belep(u)" [title]="'Megnyitás: ' + nevMegjelenit(u)">
    <span class="mod-cimke" [style.background]="adozasiForma(u) === 'TAO' ? '#eef1f4' : '#fbeee6'" [style.color]="adozasiForma(u) === 'TAO' ? '#475467' : '#c2410c'">{{ adozasiForma(u) }}</span>
    <span class="azon">{{ u.azonosito }}</span>
    <div class="nev">{{ nevMegjelenit(u) }}</div>
    <div class="meta">
      <span *ngIf="u.megjelenites_nev">{{ u.nev }}<br></span>
      <span *ngIf="u.adoszam">Adószám: {{ u.adoszam }}<br></span>
      <span *ngIf="u.telepules">{{ u.irsz }} {{ u.telepules }}, {{ u.cim }}</span>
    </div>
    <div class="cimkek">
      <span class="cimke petrol" *ngIf="u.virtualis" title="Kapcsolt mód: a Könyvelés ügyfele – kiválasztáskor jön létre a bér-ügyfele">a Könyvelésből</span>
      <span class="cimke sarga" *ngIf="u.kapcsolatlan" title="Kapcsolt módban: ez a bér-ügyfél nincs könyvelési ügyfélhez kötve (Ügyfél adatai → Könyvelési ügyfél)">nincs összekötve</span>
      <span class="cimke petrol" *ngIf="u.naplo_el && !u.virtualis" title="Össze van kötve könyvelési ügyféllel">NAPLO</span>
      <span class="cimke" *ngIf="u.sulinform_feladatellatas" [title]="'Jelenlét a SULINFORM-ból: ' + u.sulinform_feladatellatas">SULINFORM</span>
      <span class="cimke" *ngIf="u.kifizetohelyi">Kifizetőhely</span>
    </div>
    <div class="tile-lab">
      <div class="tile-muvelet" *ngIf="u.id" (click)="$event.stopPropagation()">
        <button type="button" (click)="szerkeszt(u)" title="Ügyfél adatai"><ion-icon name="create-outline"></ion-icon></button>
        <button type="button" class="konyv" (click)="atvaltKonyveles(u)" *ngIf="naploElerheto"
                [title]="u.naplo_el ? 'Átváltás a könyvelésre' : 'Könyvelés – ez a cég még nincs összekötve könyvelési ügyféllel'">
          <ion-icon name="calculator-outline"></ion-icon></button>
        <button type="button" class="torol" (click)="torol(u)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
      </div>
    </div>
  </div>
</div>

<!-- Ügyfél szerkesztése -->
<ion-modal #ugyfelModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi()">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>{{ szerk?.id ? 'Ügyfél szerkesztése' : 'Új ügyfél' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="ugyfelModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zarUgyfel"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Azonosító</span><input type="text" [(ngModel)]="szerk.azonosito" placeholder="automatikus, ha üres"></label>
        <label class="kv-mezo"><span>Hivatalos név *</span><input type="text" [(ngModel)]="szerk.nev"></label>
        <label class="kv-mezo"><span>Megjelenítési név</span><input type="text" [(ngModel)]="szerk.megjelenites_nev" placeholder="ha üres, a hivatalos név látszik"></label>
        <label class="kv-mezo"><span>Adószám</span><input type="text" [(ngModel)]="szerk.adoszam"></label>
        <label class="kv-mezo"><span>Adóazonosító jel</span><input type="text" [(ngModel)]="szerk.adoazonosito"></label>
        <label class="kv-mezo"><span>Irányítószám</span><input type="text" [(ngModel)]="szerk.irsz"></label>
        <label class="kv-mezo"><span>Település</span><input type="text" [(ngModel)]="szerk.telepules"></label>
        <label class="kv-mezo"><span>Cím</span><input type="text" [(ngModel)]="szerk.cim"></label>
        <label class="kv-mezo"><span>Bankszámla</span><input type="text" [(ngModel)]="szerk.bankszamla"></label>
        <label class="kv-mezo"><span>E-mail</span><input type="email" [(ngModel)]="szerk.email"></label>
        <div class="nk-kapcs">
          <label><input type="checkbox" [(ngModel)]="szerk.kifizetohelyi"> TB-kifizetőhely</label>
          <label><input type="checkbox" [(ngModel)]="szerk.kivas"> KIVA-alany (13% szocho helyett 10% KIVA)</label>
          <label><input type="checkbox" [(ngModel)]="szerk.atalanyado"> Átalányadózó egyéni vállalkozó</label>
          <label><input type="checkbox" [(ngModel)]="szerk.kata"> KATA</label>
          <label><input type="checkbox" [(ngModel)]="szerk.inaktiv"> Inaktív</label>
        </div>
        <!-- Összekötés a Könyvelés (NAPLO) ügyfelével: közös NAV-kapcsolat, bérfeladás, átalányadós bevétel. -->
        <label class="kv-mezo"><span>Könyvelési ügyfél</span>
          <select [(ngModel)]="szerk.naplo_ugyfel_id">
            <option [ngValue]="null">— nincs összekötve —</option>
            <option *ngFor="let n of naploUgyfelek" [ngValue]="n.id">{{ n.nev }}{{ n.adoszam ? ' · ' + n.adoszam : '' }}</option>
          </select></label>
        <p class="halvany" style="margin:-4px 0 0;font-size:12px">Összekötve a NAV M2M-kapcsolatot elég egy helyen beállítani (a Könyvelésben vagy itt),
          és a bérfeladás is ehhez az ügyfélhez könyvel.</p>
        <label class="kv-mezo" *ngIf="feladatellatasok.length"><span>SULINFORM intézmény</span>
          <select [(ngModel)]="szerk.sulinform">
            <option value="">— nincs (a jelenlét a BÉR-ben rögzül) —</option>
            <option *ngFor="let f of feladatellatasok" [value]="f.id">{{ f.name }} ({{ f.id }})</option>
          </select></label>
        <p class="halvany" *ngIf="szerk.sulinform" style="margin:-4px 0 0;font-size:12px">A munkatársak importálhatók, a jelenlét és a szabadság
          a SULINFORM-ból vehető át, és a BÉR-ben javított napok oda visszaíródnak.</p>
        <!--  Ha az iskola MÁSIK installáción van: kapcsolati kóddal (kapcsolat.js). Ugyanaz a
              munkatárs-import, jelenlét- és költség-átvétel, csak olvasva (nem ír vissza). -->
        <div class="kv-mezo" *ngIf="szerk.id"><span>SULINFORM másik rendszerből (kapcsolati kód)</span>
          <app-kapcsolat-valaszto [vegpont]="'/api/ber-sulinform/kapcsolat/' + szerk.id" (valtozott)="kapcsolatValtozott($event)"></app-kapcsolat-valaszto></div>
        <label class="kv-mezo" *ngIf="iktatok.length"><span>Iktató</span>
          <select [(ngModel)]="szerk.iktato_intezmeny" (ngModelChange)="szerk.iktato_konyv = ''">
            <option value="">— nincs iktatás —</option>
            <option *ngFor="let i of iktatok" [value]="i.intezmeny">{{ i.nev || i.intezmeny }}{{ i.konyv_db ? ' · ' + i.konyv_db + ' iktatókönyv' : ' · még nincs iktatókönyv' }}</option>
          </select></label>
        <label class="kv-mezo" *ngIf="szerk.iktato_intezmeny"><span>Iktatókönyv</span>
          <select [(ngModel)]="szerk.iktato_konyv">
            <option value="">— válassz —</option>
            <option *ngFor="let k of iktatoKonyvek" [value]="k.id">{{ k.nev }}{{ k.ev ? ' · ' + k.ev : '' }}{{ k.jel ? ' (' + k.jel + ')' : '' }}</option>
          </select></label>
        <p class="halvany" *ngIf="szerk.iktato_intezmeny" style="margin:-4px 0 0;font-size:12px">Ide iktat a rendszer, ha a Bérből iktatsz
          (pl. munkaszerződés, bérjegyzék) – az iratkezelés szabályai az Iktatgató moduléi maradnak.</p>
        <label class="kv-mezo" *ngIf="szerk.atalanyado"><span>Költséghányad</span>
          <select [(ngModel)]="szerk.atalany_koltseghanyad"><option *ngFor="let k of khanyadok" [ngValue]="k.value">{{ k.label }}</option></select></label>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="mentes()" [disabled]="zarUgyfel && !zarUgyfel.irhato"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- Import a NAPLO ügyféltörzséből -->
<ion-modal #importModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Import a NAPLO ügyféltörzséből</ion-title>
      <ion-buttons slot="end"><ion-button (click)="importModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form">
        <p *ngIf="!naploUgyfelek.length" class="halvany">A NAPLO-ban nincs ügyfél, vagy mind importálva van.</p>
        <div class="tabla-wrap" *ngIf="naploUgyfelek.length" style="margin:0">
          <table class="n-racs">
            <thead><tr><th style="width:34px"></th><th>Név</th><th>Adószám</th><th>Település</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let n of naploUgyfelek" [class.rendezett]="n.importalva">
                <td><input type="checkbox" [(ngModel)]="importValasztott[n.id]" [disabled]="n.importalva"></td>
                <td>{{ n.nev }}</td><td>{{ n.adoszam }}</td><td>{{ n.irsz }} {{ n.telepules }}</td>
                <td><span class="cimke zold" *ngIf="n.importalva">már importálva</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="nk-lab" *ngIf="naploUgyfelek.length"><button type="button" class="ov-gomb fo" (click)="importMent()"><ion-icon name="download-outline"></ion-icon>Kijelöltek importálása</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!--  ÜGYFÉLKÖR: kapcsolt módban a Könyvelés ügyfelei (a Könyvelés a központ), önállóan a saját törzs
      (backend/ugyfeltorzs.js). Alapból automatikus: kapcsolt, ha a Könyvelés aktív. -->
<div class="ber-ugyfelkor" style="margin:22px 16px 30px;display:grid;gap:8px;max-width:760px">
  <button type="button" class="ov-link" (click)="ugyfelkorNyitva = !ugyfelkorNyitva">{{ ugyfelkorNyitva ? '▾' : '▸' }} Ügyfélkör beállítása (önálló / kapcsolt)</button>
  <app-ugyfelkor-beallitas *ngIf="ugyfelkorNyitva" alrendszer="BER" (valtozott)="betolt()"></app-ugyfelkor-beallitas>
</div>
